<template>
  <div v-if="!leadDiscounts" class="lds-ellipsis">
    <div />
    <div />
    <div />
  </div>
  <div v-else>
    <h5 class="mx-3">Discounts</h5>
    <div class="row mx-3" v-if="leadDiscounts.length">
      <div class="col-12 border-bottom mb-1">
        <div class="row">
          <div class="col-4 text-center font-weight-bold">
            Name
          </div>
          <div class="col-4 text-center font-weight-bold">
            Amount
          </div>
          <div class="col-4 text-center" />
        </div>
      </div>
      <div v-for="discount in leadDiscounts" :key="discount.id" class="col-12 border-bottom mb-1">
        <div class="row">
          <div class="col-4 text-center">
            {{ discount.name }}
          </div>
          <div class="col-4 text-center">
            <template v-if="discount.discount_unit_type_id === 1">
              ${{ discount.amount }}
            </template>
            <template v-else-if="discount.discount_unit_type_id === 2">
              {{ discount.amount }}%
            </template>
          </div>
          <div class="col-4 text-center">
            <template v-if="lead.status_id !== 2">
              <div :id="'dropdownMenuButtonEditDiscount' + discount.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <i aria-hidden="true" class="fa fa-ellipsis-h text-secondary" />
              </div>
              <div class="dropdown-menu"
                   :aria-labelledby="'dropdownMenuButtonEditDiscount' + discount.id"
              >
                <a class="dropdown-item p-1 small"
                   href="#"
                   @click.prevent="openUpdateLeadDiscount(discount)"
                >
                  Edit
                </a>
                <a class="dropdown-item p-1 small"
                   href="#"
                   @click.prevent="leadDiscountDelete = discount"
                >
                  Delete
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-1" v-if="lead.status_id !== 2 && ($_can('jobs.discount.add.carrier.covered') || $_can('jobs.discount.add.office.covered') || $_can('jobs.discount.add.general.covered'))">
      <div class="col" v-if="!showNewDiscount">
        <button type="button" class="add-button pointer" @click="showNewDiscount = true">
          Add discount
          <span class="ml-2 mr-0">
            <span class="mod-icon-add" />
          </span>
        </button>
      </div>
      <template v-else>
        <div class="col-3 form-group">
          <div class="select-wrap">
            <label>Name</label>
            <div class="amount-wrap-small">
              <input type="text" class="form-control" v-model="leadDiscount.name" />
              <button type="button"
                      class="btn input-group-btn edit-transaction-remove mr-1"
                      @click="clearNewDiscount"
              >
                <i class="fa fa-remove" />
              </button>
            </div>
          </div>
          <error-field :errors="errors" field="name" />
        </div>

        <div class="col-3 form-group">
          <div class="select-wrap">
            <label>Unit</label>
            <simple-select v-model="leadDiscount.discount_unit_type_id"
                           :hide-deselect="true"
                           :options="discountUnitTypes"
                           label="name"
                           placeholder="Select"
                           @input="errors.clear('discount_unit_type_id')"
            />
          </div>
          <error-field :errors="errors" field="discount_unit_type_id" />
        </div>

        <div class="col-3 form-group">
          <div class="select-wrap">
            <label>Amount</label>
            <div class="amount-wrap-small">
              <span v-if="leadDiscount.discount_unit_type_id === 1" class="dollar mt-3 pt-1">$</span>
              <span v-else-if="leadDiscount.discount_unit_type_id === 2" class="dollar mt-3 pt-1">%</span>

              <input type="text" class="form-control" v-model="leadDiscount.amount" />
            </div>
          </div>
          <error-field :errors="errors" field="amount" />
        </div>
        <div class="col-3 form-group d-flex">
          <button class="btn btn-primary"
                  :disabled="loadingButton"
                  :class="loadingButton ? 'running' : ''"
                  @click.prevent="saveNewDiscount"
          >
            Save
          </button>
        </div>
      </template>
    </div>


    <modal
      v-if="leadDiscountEdit !== null"
      @close="leadDiscountEdit = null; errors.clear();"
      @ok="updateDiscount"
    >
      <div slot="header">
        <h4>Edit discount</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Name </label>
              <input type="text" v-model="leadDiscountEdit.name" class="form-control" />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Amount </label>
              <input type="text" v-model="leadDiscountEdit.amount" class="form-control" />
            </div>
            <error-field :errors="errors" field="amount" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Discount type </label>
              <simple-select v-model="leadDiscountEdit.type_id"
                             :hide-deselect="true"
                             :options="discountTypes"
                             label="name"
                             placeholder="Select"
                             @input="errors.clear('type_id')"
              />
            </div>
            <error-field :errors="errors" field="type_id" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Discount unit type </label>
              <simple-select v-model="leadDiscountEdit.discount_unit_type_id"
                             :hide-deselect="true"
                             :options="discountUnitTypes"
                             label="name"
                             placeholder="Select"
                             @input="errors.clear('type_id')"
              />
            </div>
            <error-field :errors="errors" field="discount_unit_type_id" />
          </div>
        </div>
      </div>
    </modal>
    <modal v-if="leadDiscountDelete !== null" @close="leadDiscountDelete = null">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">Delete Lead Discount</h4>
      </div>
      <div slot="body">
        <p class="text-center">Are you sure to delete lead discount with name {{ leadDiscountDelete.name }}?</p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click.prevent="deleteDiscount">Yes</button>
        <button class="btn btn-danger" @click.prevent="leadDiscountDelete = null">No</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import Modal from '../Modal';
import Errors from '../../classes/Errors';

export default {
  name: 'LeadDiscounts',
  components: { Modal },
  props: {
    lead: {
      default: null,
      type: Object,
    },
  },
  data: () => ({
    leadDiscounts: null,
    leadDiscount: {
      name: '',
      amount: '',
      discount_unit_type_id: 1,
    },
    loadingButton: false,
    leadDiscountEdit: null,
    leadDiscountDelete: null,
    showNewDiscount: false,
    discountTypes: [
      {
        id: 1,
        name: 'Discount',
      },
      {
        id: 2,
        name: 'Carrier Covered',
      },
      {
        id: 3,
        name: 'Office Covered',
      },
    ],
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      discountUnitTypes: state => state.values.discountUnitTypes,
    }),
  },
  mounted() {
    this.fetchDiscounts();
  },
  methods: {
    fetchDiscounts(withoutRefresh = false) {
      if (!withoutRefresh) {
        this.leadDiscounts = null;
      }
      axios
        .get(`/leads/${this.$route.params.id}/lead-discounts`)
        .then(res => {
          this.leadDiscounts = res.data.data;
        })
        .catch(() => {
          toastr.error('Failed load discounts');
        });
    },
    saveNewDiscount() {
      this.errors.clear();
      this.loadingButton = true;
      const requestData = {
        ...this.leadDiscount,
        lead_id: this.lead.id,
        type_id: 1,
      };
      if (this.$_can('jobs.discount.add.general.covered')) {
        requestData.type_id = 1;
      } else if (this.$_can('jobs.discount.add.carrier.covered')) {
        requestData.type_id = 2;
      } else if (this.$_can('jobs.discount.add.office.covered')) {
        requestData.type_id = 3;
      }
      axios
        .post('/lead-discounts', requestData)
        .then(() => {
          this.clearNewDiscount();
          this.fetchDiscounts();
          toastr.success('Successfully added new discount!');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    clearNewDiscount() {
      this.leadDiscount = {
        name: '',
        amount: '',
        discount_unit_type_id: 1,
      };
      this.errors.clear();
      this.showNewDiscount = false;
    },
    deleteDiscount() {
      axios
        .delete(`lead-discounts/${this.leadDiscountDelete.id}`)
        .then(() => {
          this.leadDiscountDelete = null;
          this.fetchDiscounts(true);
          toastr.success('Successfully deleted discount!');
        })
        .catch(error => {
          if (error.response.data && error.response.data.error.error) {
            error.response.data.error.error.map(errorMsg => toastr.error(errorMsg));
          } else {
            toastr.error('Failed delete discount!');
          }
        });
    },
    updateDiscount() {
      this.errors.clear();
      const requestData = {
        ...this.leadDiscountEdit,
        amount: parseFloat(this.leadDiscountEdit.amount),
      };
      axios
        .put(`lead-discounts/${this.leadDiscountEdit.id}`, requestData)
        .then(() => {
          this.fetchDiscounts(true);
          this.leadDiscountEdit = null;
          toastr.success('Successfully updated lead discount');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    openUpdateLeadDiscount(leadDiscount) {
      this.leadDiscountEdit = { ...leadDiscount };
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/leads/LeadDiscounts.vue